import CommonTooltip from 'src/components/ui/tooltip/CommonTooltip';
import { InputProps } from '../OdfjellInputComponent';

const TooltipComponent: React.FC<Partial<InputProps>> = ({ hideIfEmpty, value, tooltipId, description }: Partial<InputProps>) => {
    if (!description || (hideIfEmpty && !(value || value === 0))) {
        return <></>;
    }

    const content = <span className={'input-value-description'}>{description}</span>;

    return tooltipId ? <CommonTooltip tooltipId={tooltipId}>{content}</CommonTooltip> : content;
};

export default TooltipComponent;
